<template>
  <el-drawer
    :visible.sync="drawer"
    direction="rtl"
    append-to-body
    :with-header="false"
    :before-close="handleClose"
    size="600px"
  >
    <div class="drawer-wrap">
      <common-header :node-data="{ ...form, type: nodeData.type }" @close="handleClose" />
      <main>
        <!-- 审批人设置 -->
        <h2>{{ $t('744') }}:</h2>
        <!--
           抄送人 or 审批人展示
           cc 抄送 auditor审批人
          -->
        <div v-for="els in loopView" :key="els">
          <el-tabs v-model="activeName" class="app-taps" type="border-card">
            <el-tab-pane :label="$t(els === 'auditor' ? 'work_rule_34' : 'cc')" name="first">
              <el-form
                v-for="(element, i) in form[els]"
                ref="ruleForm"
                :key="i"
                :model="element"
                :rules="rules"
                class="loop-form"
              >
                <!-- 删除 -->
                <i
                  v-if="els === 'cc' || form[els].length > 1"
                  class="el-icon-delete del-branch-item"
                  @click="handlerDel(i, els)"
                />
                <!-- 审批类型 -->
                <ApprovalType
                  :options="cEnum.dynamicRadio"
                  v-model="element.settype"
                  @change="handleChangeElement(element)"
                  key="approval"
                />
                <!-- 动态组件渲染 -->
                <component
                  :is="dynamicComponent(element.settype)"
                  :node-data="element"
                  key="component"
                  :options="getSelectList(element.settype)"
                />
              </el-form>
              <!-- 配置项 -->
              <div>
                <!-- 增加审批人 or 抄送人 按钮 -->
                <el-button
                  type="text"
                  icon="el-icon-plus"
                  class="add-condition-list"
                  @click="handlerAddApproval(els)"
                  >{{ $t(els === 'auditor' ? 'work_rule_34' : 'cc') }}</el-button
                >
                <!-- 审批人配置项 -->
                <div v-if="els === 'auditor'">
                  <!-- 审批人全部离职 -->
                  <div class="form-item">
                    <p>{{ $t('5d134ea2') }}</p>
                    <!-- 审批人全部离职  -->
                    <el-radio-group v-model="form.resign_policy">
                      <el-radio
                        v-for="(item, index) in noLeaveOfficeData"
                        :key="index"
                        :label="item.key"
                        @change="handleType('resign_policy', 'specify_resign')"
                        >{{ $t(item.label) }}</el-radio
                      >
                    </el-radio-group>
                    <!-- 审批人全部离职转交指定人员 -->
                    <div v-if="form.resign_policy === 2" class="margin-top">
                      <el-form ref="ruleForm" :rules="rules" :model="form">
                        <SelectPerson
                          :control="{ all: 0, depShow: 2, staffShow: 1, staffMax: 1 }"
                          :node-data="form"
                          key="SelectPerson"
                          valueKey="specify_resign"
                        />
                      </el-form>
                    </div>
                  </div>
                  <!-- 审批人为空时 -->
                  <div class="form-item">
                    <p>{{ $t('172') }}</p>
                    <!-- 审批人为空时选项 -->
                    <el-radio-group v-model="form.noHanderAction">
                      <el-radio
                        v-for="(item, index) in noHanderActionData"
                        :key="index"
                        :label="item.key"
                        @change="handleType('noHanderAction', 'directorLevelPerson')"
                        >{{ $t(item.label) }}</el-radio
                      >
                    </el-radio-group>
                    <!-- 审批人为空转交指定人员 -->
                    <div v-if="form.noHanderAction === 2" class="margin-top">
                      <el-form ref="ruleForm" :rules="rules" :model="form">
                        <SelectPerson
                          :control="{ all: 0, depShow: 2, staffShow: 1, staffMax: 1 }"
                          :node-data="form"
                          key="SelectPerson"
                          valueKey="directorLevelPerson"
                        />
                      </el-form>
                    </div>
                  </div>
                  <!-- 审批人展示 会签或签 -->
                  <div class="form-item">
                    <p>{{ $t('work_rule_44') }}</p>
                    <el-radio-group v-model="form.node_audit_type">
                      <el-radio v-for="(item, index) in manyPeopleApproval" :key="index" :label="item.key">{{
                        $t(item.label)
                      }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <!-- 仅同意时抄送 -->
                <div v-else>
                  <el-checkbox v-model="form.ccPolicy">{{ $t('approval-cc') }}</el-checkbox>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </main>
      <footer>
        <el-button plain round size="small" @click="handleClose"> {{ $t('cancel_btn') }}</el-button>
        <el-button type="primary" round size="small" @click="handlerSave">{{ $t('save_btn') }}</el-button>
      </footer>
    </div>
  </el-drawer>
</template>

<script>
import './drawer.scss'
import componemtsMaps, {
  formAuditor,
  approvalMap,
  manyPeopleApproval,
  noHanderActionData,
  noLeaveOfficeData
} from '../examples'
import { getWorkflowNoteInfo } from 'api/flow'
import CommonHeader from '../components/common-header'
import SelectPerson from '../components/select-person'
import ApprovalType from '../components/approval-type'
import { approvalRules } from '../rules'
import Org from '@/components/organization'

export default {
  components: {
    CommonHeader,
    SelectPerson,
    ApprovalType,
    Org
  },
  props: {
    // 组件是否展示
    drawer: {
      default: false,
      type: Boolean
    },
    // 当前节点数据
    nodeData: {
      default: () => ({}),
      type: Object
    },
    directorLevel: {
      type: Number
    }
  },
  data() {
    return {
      // 循环项
      loopView: ['auditor', 'cc'],
      noHanderActionData,
      noLeaveOfficeData,
      // 多人审批签字选项
      manyPeopleApproval,
      // approverVisible: false,
      // Taps下标
      activeName: 'first',
      // Title编辑状态
      isEdit: false,
      // 校验
      rules: approvalRules,
      cEnum: {
        directorLevelPerson: [], // 审批人为空指定审批人
        specify_resign: [], // 审批人全部离职
        dynamicRadio: []
      },
      isPerson: true,
      form: {
        specify_resign: [],
        settype: 1 // 审批人类型
      }
    }
  },
  computed: {
    // 动态组件切换
    // 根据节点类型展示对应的选项
    dynamicRadio() {
      return approvalMap.filter(item => {
        return item.type.includes(this.nodeData.settype)
      })
    }
  },
  created() {
    // 数据拷贝 具体查看数据结构
    const data = JSON.parse(JSON.stringify(this.nodeData))
    this.form = {
      ...this.form,
      ...data.form
    }
    this.handleGetWorkflowNoteInfo()
  },
  methods: {
    handleType(val, key) {
      if (this.form[val] !== 2) {
        this.form[key] = []
      }
    },
    /**
     * 切换选项清空值
     * @param { Object } element 当前对象
     */
    handleChangeElement(element) {
      this.$set(element, 'val', '')
    },
    /**
     * 获取下拉选项
     * SetType所选类型
     * @param { number } setType
     */
    getSelectList(setType) {
      const { dynamicRadio } = this.cEnum
      const arr = dynamicRadio.filter(item => item.type === setType)
      return arr.length ? arr[0].option : []
    },
    // 获取组件类型选项（审批人或抄送人）
    async handleGetWorkflowNoteInfo() {
      const res = await getWorkflowNoteInfo()
      this.cEnum.dynamicRadio = res.data
    },
    // 动态组件切换
    dynamicComponent: type => componemtsMaps.get(type),
    /**
     * @description 添加条件组
     * @param { string } key 抄送人or审批人
     */
    handlerAddApproval(key) {
      const addTarget = this.form[key]
      Array.isArray(addTarget) && addTarget.push(formAuditor())
    },
    // 组件关闭操作
    handleClose() {
      this.$emit('update:drawer', false)
    },
    // 删除条件组
    // @parma { Number } i 对应数组的下标
    // @parma { key } 要删除对象的key
    handlerDel(i, key) {
      this.form[key].splice(i, 1)
    },
    // 保存
    handlerSave() {
      // 条件组循环校验
      const state = this.$refs.ruleForm.every(item => {
        let result = true
        item.validate(valid => (result = valid))
        return result
      })
      if (this.form.noHanderAction === 2) {
        this.isPerson = !!this.form.directorLevelPerson.length
      }
      if (this.form.resign_policy === 2) {
        this.isPerson = !!this.form.specify_resign.length
      }
      // 校验通过
      if (state && this.isPerson) {
        const result = {
          ...this.nodeData,
          form: this.form
        }
        this.$emit('change', result)
        this.handleClose()
      }
    }
  }
}
</script>
